import { Outlet } from 'react-router-dom';

const ManagementOutlet = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ManagementOutlet;
